// Build/release metadata shown in the app footer.
// Overridable by the deploy pipeline via REACT_APP_BUILD_NUMBER / REACT_APP_BUILD_TIME.
const envNumber = process.env.REACT_APP_BUILD_NUMBER;
const envTime = process.env.REACT_APP_BUILD_TIME;
const envName = process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

export const BUILD = {
  major: 1,
  minor: 0,
  number: envNumber || "1.0.0",
  publishedAt: envTime || "2026-06-13T14:30:00+08:00",
  env: envName.charAt(0).toUpperCase() + envName.slice(1),
};

export const fmtBuildTime = (iso) => {
  try {
    return (
      new Date(iso).toLocaleString("en-SG", {
        timeZone: "Asia/Singapore",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }) + " SGT"
    );
  } catch {
    return iso;
  }
};
